import { checkIsPlatform, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getSingleItemWidgetStyles = (index, numberOfColumns, itemCount) => {
  var isLeftColumn = index % numberOfColumns === 0;
  var isLastRow = Math.floor(index / numberOfColumns) === Math.floor((itemCount - 1) / 2);
  var marginStyles = {
    marginRight: isLeftColumn ? tokens.spacing.SPACING_6 : 0,
    marginLeft: !isLeftColumn ? tokens.spacing.SPACING_6 : 0,
    marginBottom: isLastRow ? 0 : tokens.spacing.SPACING_12
  };
  var leftItemStyle = isLastRow ? checkIsPlatform('web') ? styles.leftColumnStyleWeb : styles.leftColumnStyle : {};
  var marginBottomForSingleColumn = index == itemCount - 1 ? {
    marginBottom: 0
  } : {};
  if (numberOfColumns === 1) {
    return Object.assign(Object.assign({}, styles.singleLineSingleColumn), marginBottomForSingleColumn);
  }
  return Object.assign(Object.assign(Object.assign({}, styles.singleLineMultiColumn), marginStyles), leftItemStyle);
};
var styles = StyleSheet.create({
  singleLineSingleColumn: {
    width: '100%',
    marginBottom: tokens.spacing.SPACING_12
  },
  singleLineMultiColumn: {
    marginBottom: tokens.spacing.SPACING_12,
    flex: 1,
    flexGrow: 1
  },
  leftColumnStyleWeb: {
    flex: 0,
    flexGrow: 0,
    flexBasis: 'calc(50% - 6px)'
  },
  leftColumnStyle: {
    flexGrow: 0.5,
    flexShrink: 0.1
  }
});